import React from 'react';

const firstTruthy = (...readers) => readers.reduce((result, read) => result || read(), undefined);

export function useCanvasRevisionApplyAction({
  canvasActiveTabKey = '',
  commitCanvasDraftValue,
  markCanvasDraftSaved,
  setCanvasActiveTabKey,
} = {}) {
  return React.useCallback(async (revisionEntry = {}) => {
    const revisionContent = String(firstTruthy(() => Object(revisionEntry).content, () => '')).trim();
    const revisionTabKey = firstTruthy(() => String(
      Object(revisionEntry).active_tab
      || canvasActiveTabKey
      || 'requirement'
    ).trim(), () => 'requirement');
    if (firstTruthy(() => !revisionContent, () => Object(revisionEntry).can_rollback === false)) {
      return;
    }
    setCanvasActiveTabKey?.(revisionTabKey);
    const result = await commitCanvasDraftValue?.(revisionContent, {
      closeEditor: false,
      saveMeta: {
        changeOperation: 'rollback_to_revision',
        changeSummary: `回滚到${firstTruthy(() => Object(revisionEntry).label, () => '历史版本')}`,
        sourceKind: 'revision_rollback',
        sourceAction: firstTruthy(() => Object(revisionEntry).action, () => revisionEntry),
      },
      syncEditorValue: true,
      targetTabKey: revisionTabKey,
    });
    if (result?.status === 'completed') markCanvasDraftSaved?.(revisionTabKey, revisionContent);
    return result;
  }, [
    canvasActiveTabKey,
    commitCanvasDraftValue,
    markCanvasDraftSaved,
    setCanvasActiveTabKey,
  ]);
}

export default useCanvasRevisionApplyAction;
